import { render } from "./SCard.vue?vue&type=template&id=083792b2"
const script = {}

import exportComponent from "../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__